<template>
    <div>
        <div v-if="id" class="modal-backdrop fade show"></div>
        <app-table
            v-if="id == 'table'"
            :show="id == 'table'"
            @onClose="() => { id = null }"
            :data="data.appends"
            :append="append"
            @onAppend="onAppend"
            :countries="countries"
            @onDelete="onDelete">
        </app-table>
        <div class="col-12 d-flex justify-content-between">
            <p class="card-subtitle mb-3">
                A continuación cargue la lista de participantes:
            </p>
            <a :href="format" download target="_blank" class="card-subtitle mb-3"><b>Descargar Formato</b></a>
        </div>
        <div class="col-12">
            <div class="form-group">
                <label>Archivo : <span class="text-muted">(Opcional)</span></label>
                <v-app>
                    <v-file-input v-model="data.file"
                      :loading="upload > 0"
                      @click:clear="onClear"
                      @change="onValidate"
                      class="form-control d-flex"
                      placeholder="Seleccionar archivo"
                      outlined
                      hide-details
                      accept=".xlsx, .xls, .csv"
                      dense>
                    </v-file-input>
                </v-app>
            </div>
        </div>
        <div class="col-12">
          <p class="mb-0">o agrega participantes</p>
        </div>
        <div class="col-md-4">
          <button class="btn btn-success w-100" @click="() => { id = 'table' }">
            <span>
                <i class="ti ti-save me-1 fs-4"></i> Agregar participante
            </span>
          </button>
        </div>
        <div class="col-12">
          <p class="mb-0">Se cargaron {{ data.participants ? data.participants : 0 }} participantes</p>
        </div>
    </div>
</template>
<script>
import format from '@/assets/Formato.xlsx'
import AppTable from '@/pages/home/steps/TableParticipants'
export default {
  components: { AppTable },
  props: {
    data: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      format,
      upload: 0,
      id: null,
      append: {},
      countries: []
    }
  },
  created () {
    this.$axios({
      url: '/countries',
      method: 'GET'
    })
      .then((resp) => {
        this.countries = resp.data
      })
  },
  methods: {
    onValidate: function (event) {
      if (this.data.file) {
        this.upload++
        this.$emit('onUpload', true)
        if (this.upload === 1) {
          let form = new FormData()
          form.append('file', this.data.file)
          this.$axios({
            url: '/validate/participants',
            method: 'POST',
            data: form
          })
            .then((resp) => {
              this.data.participants += resp.data
              this.$emit('onUpload', false)
              this.upload = 0
            })
            .catch((err) => {
              let message = err.response ? err.response.data.message : err.message
              this.$swal({ toast: true, icon: 'error', title: message, position: 'top-end', showConfirmButton: false, timer: 3000 })
              this.$emit('onUpload', false)
              this.upload = 0
            })
        }
      } else {
        this.$emit('onUpload', false)
        this.upload = 0
      }
    },
    onClear: function (e) {
      this.data.participants = this.data.appends.length
      this.data.file = null
      this.$emit('onUpload', false)
      this.upload = 0
    },
    onAppend: function (append) {
      if (!append.name || !append.age || !append.gender || !append.country) {
        this.$swal({ toast: true, icon: 'error', title: 'Debes ingresar todos los campos', position: 'top-end', showConfirmButton: false, timer: 3000 })
        return
      }
      let exist = this.data.appends.findIndex((e) => e.cui === append.cui && e.cui)
      if (exist !== -1) {
        this.$swal({ toast: true, icon: 'error', title: 'El cui ya se encuentra agregado', position: 'top-end', showConfirmButton: false, timer: 3000 })
        return
      }
      append.age = Number(append.age)
      this.data.participants++
      this.data.appends.push(append)
      this.append = {}
    },
    onDelete: function (index) {
      this.data.appends.splice(index, 1)
      this.data.participants--
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/home/steps/Participants.vue